export const mapFetchStoreHousResponse = (response) => {
  const mapToEntities = (items) =>
    items.map((item) => ({
      dayWeek: item['DiaDaSemana'],
      openHours: item['HoraAbertura'],
      closeHours: item['HoraFechamento'],
    }));

  return {
    delivery: mapToEntities(response['HorariosFuncionamentoDelivery'] || []),
    pickup: mapToEntities(response['HorariosFuncionamentoBalcao'] || []),
  };
};

export const mapFetchStoreExceptionResponse = (response) => {
  const isAllDay = (startTime, endTime) => {
    const allDayStart = '00:00';
    const allDayEnd = '23:59';
    return startTime.includes(allDayStart) && endTime.includes(allDayEnd);
  };

  const mapToEntities = (items) =>
    items.map((item) => ({
      exceptionDate: new Date(item['DataExcecao']),
      delivery: item['Delivery'],
      openHours: item['HoraAbertura'],
      closeHours: item['HoraFechamento'],
      close: isAllDay(item['HoraAbertura'], item['HoraFechamento']),
    }));

  return {
    delivery: mapToEntities(response['HorariosExcecaoDelivery'] || []),
    pickup: mapToEntities(response['HorariosExcecaoBalcao'] || []),
  };
};

export const mapOpenHoursToApiResponse = (request) => {
  const mapToRequest = (operatingDays) =>
    operatingDays.reduce(
      (operatingDaysAcc, operatingDay, index) => [
        ...operatingDaysAcc,
        ...(operatingDay.enabled
          ? operatingDay.hours.map((hour) => ({
              DiaDaSemana: index,
              HoraAbertura: hour.start,
              HoraFechamento: hour.end,
            }))
          : []),
      ],
      []
    );

  return {
    HorariosFuncionamentoDelivery: mapToRequest(request.delivery),
    HorariosFuncionamentoBalcao: mapToRequest(request.pickup),
  };
};

export const mapOpenHoursExceptionToApiResponse = (request) => {
  const mapToRequest = (exceptionDays, isDelivery) =>
    exceptionDays.map((exceptionDay) => ({
      DataExcecao: exceptionDay.date,
      Delivery: isDelivery,
      HoraAbertura: exceptionDay.startHour,
      HoraFechamento: exceptionDay.endHour,
    }));

  return {
    HorariosExcecao: [
      ...mapToRequest(request.delivery, true),
      ...mapToRequest(request.pickup, false),
    ],
  };
};
